import { otherClient } from "../client/other-client";

export const getAuditTrail = async (
  page,
  limit,
  startDate,
  endDate,
  search,
  userId
) => {
  try {
    const params = new URLSearchParams();
    if (page != null) params.append("page", page);
    if (limit != null) params.append("limit", limit);
    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);
    if (search) params.append("q", search);
    if (userId) params.append("userId", userId);
    const response = await otherClient.get(`api/audit?${params.toString()}`);
    return response;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const downloadAuditTrail = async (
  page,
  limit,
  startDate,
  endDate,
  userId,
  exportType
) => {
  try {
    const params = new URLSearchParams();
    if (page != null) params.append("page", page);
    if (limit != null) params.append("limit", limit);
    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);
    if (userId) params.append("userId", userId);
    if (exportType) params.append("export", exportType);
    const response = await otherClient.get(`/api/audit?${params.toString()}`);
    return response;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const downloadSelectedAuditTrail = async (selectedTrails) => {
  try {
    const response = await otherClient.post(`/api/audit/export-selected`, {
      ids: selectedTrails,
      format: "csv",
    });
    return response;
  } catch (error) {
    throw error?.response?.data || error;
  }
};
